import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  TemplateRef,
} from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { PropertiesDialogComponent } from "src/app/page/field-layout/properties-dialog/properties-dialog.component";
import { ToastService } from "ng-uikit-pro-standard";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppConfig } from "src/app/config";
import { GUID } from "./../../guid";
import { DataService } from "src/app/data.service";
import { EmptySectionComponent } from "src/app/page/empty-section/empty-section.component";
import { TranslationService } from "src/app/translation.service";

@Component({
  selector: "app-globalaction-layout",
  templateUrl: "./globalaction-layout.component.html",
  styleUrls: ["./globalaction-layout.component.scss"],
})
export class GlobalactionLayoutComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;

  @ViewChild("translateGroupDialog", { static: false })
  translateGroupDialog!: TemplateRef<any>;
  translateGroupDialogRef: MatDialogRef<any>;
  sectionsData: { sectionName: string; translategroup: any[] }[] = [];
  layoutgrouplabel = [];

  showElements1: boolean = true;
  showElements2: boolean = true;
  newSection: any;
  sectionCounter: number = 1;
  inputField: any[] = [];
  sectionList: any[] = [];
  droppedDataFieldList: any[] = [];
  droppedDataButtonList: any[] = [];
  layoutbutton: any[] = [];

  groupfieldattributes: any = {};
  groupfields: any = {};

  propertiesfield: any = {};

  visible: boolean;
  readonly: false;
  required: false;

  hidden: false;
  islink: false;
  linkfield: "";
  linkrelativeurl: "";
  object: "";
  recordtypeexist: false;
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  column: number;
  imageSection: boolean;
  systemSection: boolean;
  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;
  profileId = "";
  metaobjectId = " ";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  Name = "";
  fieldHistory = false;
  approvalHistory = false;
  Team = false;
  pathSetting = false;
  viewName = "";
  publicAccess = false;
  mode = "";
  Id = "";
  guid: GUID;
  metalayout: any;
  metaLayoutGroupId = "";
  metaProfileLayoutWebId = "";
  metaLayoutGroupIdSection = "";
  actionType = "";
  recordTypes = [];
  queues = [];
  queueList = [];
  fields = [];
  fieldList = [];
  operatorList = [];
  picklistValueList = [];

  fieldsToDo = [];
  fieldsDone = [];

  @ViewChild("componentContainer", { read: ViewContainerRef, static: false })
  componentContainer!: ViewContainerRef;
  @ViewChild("componentContainer1", { read: ViewContainerRef, static: false })
  componentContainer1!: ViewContainerRef;
  @ViewChild("childComponentRef", { read: ViewContainerRef, static: false })
  childComponentRef: ViewContainerRef;

  @ViewChild(PropertiesDialogComponent, { static: false })
  propertiesDialog: PropertiesDialogComponent;
  @ViewChild(EmptySectionComponent, { static: false })
  emptySectionComponent: EmptySectionComponent;

  @Input() sectionProperties: any;
  @Input() Groupfieldattributes: any;

  @Output() retrievedProperties: EventEmitter<any> = new EventEmitter<any>();
  languages: any[];
  data: any;
  translatedLabels: any;
  dialogRef: any;
  dialogRefTranslation: any;
  datas: any;
  dialogRefGroupTranslation: any;
  translatedGroupLabels: any;

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    username: "",

    id: "",
    name: "",
    publicaccess: false,
    active: true,
    attributes: {},

    targeturl: "",
    columncount: 1,
    tabkeyorder: "L-R",
    hascustomview: false,
    clonable: false,
    editable: true,
    deletable: false,
    haskanbanview: true,
    searchtext: "",
    sortby: "createdon",
    sortorder: "desc",
  });

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private dialog: MatDialog,
    private router: Router,
    private toastrService: ToastService,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private route: ActivatedRoute,
    private dataService: DataService,
    private translationService: TranslationService
  ) {}
  translateForm: FormGroup;
  translateGroupForm: FormGroup;

  ngOnInit() {
    this.guid = new GUID();
    this.visible = true;

    this.readonly = false;
    this.required = false;

    console.log("inputfield", this.inputField);
    console.log("inputfield", this.layoutbutton);

    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.objectid;
      this.metaobjectName = this.route.snapshot.params.object;
      this.metaLayoutGroupId = this.route.snapshot.params.metagroupid;
      this.metalayoutName = this.route.snapshot.params.name;
      this.actionType = this.route.snapshot.params.actiontype;
      this.metalayoutId = this.route.snapshot.params.metalayoutid;
      this.Id = this.route.snapshot.params.id;
      this.Name = this.route.snapshot.params.name;

      this.retrieveMetaFields();

      if (this.mode == "edit") {
        console.log("edit edit");
        this.metalayoutId = this.route.snapshot.params.metalayoutid;
        this.metalayoutName = this.route.snapshot.params.name;
        this.metaobjectId = this.route.snapshot.params.objectid;

        console.log("edit metalayoutName", this.metalayoutName);
        console.log("edit displayname", this.displayName);

        // this.retrieveSavedData();

        // this.editData();
      }
      console.log("response00000 metalayoutId", this.metalayoutId);

      this.profileId = this.route.snapshot.params.profileid;
      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.publicaccess == "true";
      this.publicAccess = boolValue;
    });
    console.log("edit metaobjectName", this.metaobjectName);

    // if (this.mode.toLocaleLowerCase().trim() == "new") {
    if (this.mode == "new") {
      const defaultSection = {
        id: this.generateUniqueId(),
        sectionName: "New Section",
        detailPage: false,
        editPage: false,
        imageSection: false,
        systemSection: false,
        column: 2,
        droppedDataFieldList: [],
      };
      console.log("mode!", this.mode);
      this.sectionList.push(defaultSection);
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: "",
    });

    this.translateGroupForm = this.fb.group({
      translategroup: this.fb.array([]),
      code: "",
      language: "",
    });
    // Initialize with one language by default
    this.addLang();
    this.addGroupLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language,
              });
            }
            this.languages = objArr;

            // this.isLoading = false;
          } else {
            console.log("error while retrieving");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedGroupLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translatedGroupText: string = "";

  get translategroup(): FormArray {
    return this.translateGroupForm.get("translategroup") as FormArray;
  }

  addGroupLang() {
    console.log("Grouplang");
    const translateSectionGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required],
    });

    this.translategroup.push(translateSectionGroup);
  }

  // translatorgroup(index: number) {
  //   const translateSectionGroup = this.translategroup.at(index) as FormGroup;
  //   const selectedLanguage = translateSectionGroup.get("languageCode").value;
  //   const labelname = this.datas.labelname;

  //   console.log(selectedLanguage);

  //   this.translationService
  //     .translate(labelname, selectedLanguage, "en")
  //     .subscribe((response: any) => {
  //       const translatedGroupText =
  //         response.data.translations[0].translatedGroupText;
  //       translateSectionGroup
  //         .get("translatedName")
  //         .setValue(translatedGroupText);
  //     });
  // }
  translatorgroup(index: number) {
    const translateSectionGroup = this.translategroup.at(index) as FormGroup;
    const selectedLanguage = translateSectionGroup.get("languageCode").value;
    const labelname = this.datas.sectionName;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedGroupText =
          response.data.translations[0].translatedGroupText;
        translateSectionGroup
          .get("translatedName")
          .setValue(translatedGroupText);
      });
  }

  // saveGroupTranslated() {
  //   // console.log(this.translateForm);
  //   if (this.translateGroupForm.valid) {
  //     // Handle the form submission
  //     console.log(
  //       "Saving form data:",
  //       this.translateGroupForm.value.translategroup
  //     );

  //     this.translatedGroupLabels = this.translateGroupForm.value.translategroup;
  //   }
  //   this.translateGroupDialogRef.close();
  // }
  // saveGroupTranslated() {
  //   if (this.translateGroupForm.valid) {
  //     console.log(
  //       "Saving form data:",
  //       this.translateGroupForm.value.translategroup
  //     );

  //     // Save form data to sectionsData
  //     const existingSectionIndex = this.sectionsData.findIndex(
  //       (section) => section.sectionName === this.datas.sectionName
  //     );
  //     if (existingSectionIndex !== -1) {
  //       this.sectionsData[existingSectionIndex].translategroup =
  //         this.translateGroupForm.value.translategroup;
  //     } else {
  //       this.sectionsData.push({
  //         sectionName: this.datas.sectionName,
  //         translategroup: this.translateGroupForm.value.translategroup,
  //       });
  //     }
  //   }
  //   this.translateGroupDialogRef.close();
  // }
  saveGroupTranslated() {
    if (this.translateGroupForm.valid) {
      console.log(
        "Saving form data:",
        this.translateGroupForm.value.translategroup
      );

      // Save form data to sectionsData
      const existingSectionIndex = this.sectionsData.findIndex(
        (section) => section.sectionName === this.datas.sectionName
      );
      if (existingSectionIndex !== -1) {
        this.sectionsData[existingSectionIndex].translategroup =
          this.translateGroupForm.value.translategroup;
      } else {
        this.sectionsData.push({
          sectionName: this.datas.sectionName,
          translategroup: this.translateGroupForm.value.translategroup,
        });
      }
    }
    this.translateGroupDialogRef.close();
  }

  removeGroupLang(index: number) {
    this.translategroup.removeAt(index);
  }

  openTranslateGroupDialog(sectionName: any): void {
    console.log("labelname", sectionName);

    if (!sectionName) {
      return;
    }

    // Reset the form and clear previous data
    this.translateGroupForm = this.fb.group({
      translategroup: this.fb.array([]),
      code: "",
      language: "",
    });

    // Populate form with existing data if available
    const sectionData = this.sectionsData.find(
      (section) => section.sectionName === sectionName
    );
    if (sectionData) {
      sectionData.translategroup.forEach((group) => {
        const translateSectionGroup = this.fb.group({
          languageCode: [group.languageCode, Validators.required],
          translatedName: [group.translatedName, Validators.required],
        });
        this.translategroup.push(translateSectionGroup);
      });
    }

    this.datas = { sectionName: sectionName };

    this.translateGroupDialogRef = this.dialog.open(this.translateGroupDialog, {
      height: "400px",
      width: "800px",
      data: this.datas,
    });

    this.translateGroupDialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
        // Handle any post-dialog actions if needed
        this.saveGroupTranslated();
      }
    });
  }

  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metalayoutlabeltranslation: {
          metalayoutid: this.metalayoutId,
        },
      },
    };

    // this.isLoading = true;
    this.dataService.getLayoutTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.layoutgrouplabel =
            res.data.metalayouttranslation.metalayoutgrouplabeltranslation;

          // Loop through the response and add translation fields
          if (res.data.metalayouttranslation.metalayoutlabeltranslation) {
            this.translate.clear();
            res.data.metalayouttranslation.metalayoutlabeltranslation.forEach(
              (translation) => {
                const translateGroup = this.fb.group({
                  languageCode: [translation.languagecode, Validators.required],
                  translatedName: [
                    translation.translatedlabel,
                    Validators.required,
                  ],
                });
                this.translate.push(translateGroup);
              }
            );
            // After populating translateForm, update translatedLabels
            this.translatedLabels =
              res.data.metalayouttranslation.metalayoutlabeltranslation.map(
                (translation) => ({
                  languageCode: translation.languagecode,
                  translatedName: translation.translatedlabel,
                })
              );
          }

          // this.translateGroupForm.setControl(
          //   "translategroup",
          //   this.fb.array([])
          // );

          // if (res.data.metalayouttranslation.metalayoutgrouplabeltranslation) {
          //   res.data.metalayouttranslation.metalayoutgrouplabeltranslation.forEach(
          //     (translation) => {
          //       const translateGroup = this.fb.group({
          //         languageCode: [translation.languagecode, Validators.required],
          //         translatedName: [
          //           translation.translatedlabel,
          //           Validators.required,
          //         ],
          //       });
          //       this.translategroup.push(translateGroup);
          //     }
          //   );

          //   // Update sectionsData with metalayoutgrouptranslation data
          //   const sectionName = "System Information"; // Set the section name appropriately
          //   const existingSectionIndex = this.sectionsData.findIndex(
          //     (section) => section.sectionName === sectionName
          //   );
          //   if (existingSectionIndex !== -1) {
          //     this.sectionsData[existingSectionIndex].translategroup =
          //       res.data.metalayouttranslation.metalayoutgrouplabeltranslation.map(
          //         (translation) => ({
          //           languageCode: translation.languagecode,
          //           translatedName: translation.translatedlabel,
          //         })
          //       );
          //   } else {
          //     this.sectionsData.push({
          //       sectionName: sectionName,
          //       translategroup:
          //         res.data.metalayouttranslation.metalayoutgrouplabeltranslation.map(
          //           (translation) => ({
          //             languageCode: translation.languagecode,
          //             translatedName: translation.translatedlabel,
          //           })
          //         ),
          //     });
          //   }
          // }
          // console.log(
          //   res.data.metalayouttranslation.metalayoutgrouplabeltranslation
          // );
          // console.log(this.translateGroupForm.get("translategroup").value);
          // console.log(this.sectionsData);

          // this.isLoading = false;
        } else {
          console.log("no data");
          // this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        // this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translatedText: string = "";

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required],
    });

    this.translate.push(translateGroup);
  }

  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    // this.dialogRef.close();
    // if (this.dialogRef) {
    this.dialogRefTranslation.close();

    // this.dialog.close()
    // }
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  retrieveMetaFields() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metafield: {
          metaobjectid: this.metaobjectId,
        },
      },
    };

    this.isLoading = true;

    this.dataService.getMetaFields(postOption).subscribe((response: any) => {
      console.log("fields response:", response);

      if (response !== null && response.success == 1) {
        const fields = response.data.metafields;

        for (let i = 0; i < fields.length; i++) {
          var field = fields[i];

          //skip id type fields if there
          if (field.fieldtype.toLowerCase() == "id") continue;

          //skip fields with visibility false
          if (field.visible == false) continue;

          //skip fields deleted, ownertype etc.,
          if (
            field.fieldname.toLowerCase() == "deleted" ||
            field.fieldname.toLowerCase() == "ownertype" ||
            field.fieldname.toLowerCase() == "migrated" ||
            field.fieldname.toLowerCase() == "organizationid" ||
            field.fieldname.toLowerCase() == "internalid" ||
            // field.fieldname.toLowerCase() == "academic_year" ||
            // field.fieldname.toLowerCase() == "academic_session" ||
            // field.fieldname.toLowerCase() == "institution" ||
            field.fieldname.toLowerCase() == "institution_id" ||
            field.fieldname.toLowerCase() == "systemmodstamp" ||
            field.fieldname.toLowerCase() == "search" ||
            field.fieldname.toLowerCase() == "date_range"
          )
            continue;

          if (field.tenantfield == true) continue;

          //skip converted field if object is lead
          if (
            this.metaobjectName.toLowerCase().trim() == "lead" &&
            field.fieldname.toLowerCase() == "converted"
          )
            continue;
          if (field.attributes.ignorablefield == true) continue;

          field.dropped = false;
          this.inputField.push(field);
          this.isLoading = false;
        }
        if (this.mode.toLocaleLowerCase() == "edit") {
          this.retrieveSavedData();
        }
      }
    });
  }

  // checkLayout() {
  //   console.log("**********");
  //   // if(this.mode.toLocaleLowerCase() =='new'){
  //   let postOption = {
  //     organizationid: localStorage.getItem("crm_orgid"),
  //     userid: localStorage.getItem("crm_userid"),
  //     username: localStorage.getItem("crm_username"),
  //     // domain: localStorage.getItem("domain"),
  //     // subdomain: localStorage.getItem("subdomain"),
  //     domain: localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.domain`
  //     ),
  //     subdomain: localStorage.getItem(
  //       `${localStorage.getItem("crm_orgid")}.subdomain`
  //     ),
  //     data: {
  //       metalayout: {
  //         id: this.metalayoutId,
  //         action: "layout",
  //         mode: this.mode,
  //         name: this.metalayoutName,
  //         metaobjectid: this.metaobjectId,
  //         metagroupid: this.metaLayoutGroupId,
  //         embeddedobject: false,
  //       },
  //     },
  //   };
  //   console.log("postoption edit", postOption);
  //   this.isLoading = true;
  //   this.dataService.getMetalayoutByName(postOption).subscribe(
  //     (response: any) => {
  //       console.log(response);
  //       if (response.success == 0) {
  //         this.router.navigateByUrl(
  //           `home/globalaction/layout/new/${this.Id}/${this.metaobjectName}/${this.metaobjectId}/${this.Name}/${this.metalayoutId}/${this.actionType}`
  //         ).then(() => {
  //           // Use a timeout to wait for navigation to complete
  //           // setTimeout(() => {
  //             window.location.reload(); // Reload the page after navigation
  //           // }, 100); // Adjust timeout duration if necessary
  //         });

  //         // window.location.reload();
  //       }
  //     },
  //     (error: any) => {
  //       console.error("Error retrieving saved data:", error);
  //       this.errorMessage = error.message;
  //       this.isError = true;
  //       this.isLoading = true;
  //     }
  //   );
  //   // }
  // }

  retrieveSavedData() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metalayout: {
          id: this.metalayoutId,
          action: "layout",
          mode: this.mode,
          name: this.metalayoutName,
          metaobjectid: this.metaobjectId,
          metagroupid: this.metaLayoutGroupId,
          embeddedobject: false,
        },
      },
    };
    console.log("postoption edit", postOption);
    this.isLoading = true;
    this.dataService.getMetalayoutByName(postOption).subscribe(
      (response: any) => {
        console.log("response:", response);
        if (response.success == 0) {
          this.router
            .navigateByUrl(
              `home/globalaction/layout/new/${this.Id}/${this.metaobjectName}/${this.metaobjectId}/${this.Name}/${this.metalayoutId}/${this.actionType}`
            )
            .then(() => {
              window.location.reload(); // Reload the page after navigation
            });
        } else {
          console.log(response.data.metalayout.name);

          // this.Name = response.data.metalayout.name;
          // this.displayName = response.data.metalayout.displayname;
          // this.fieldHistory = response.data.metalayout.fieldhistory;
          // this.approvalHistory = response.data.metalayout.approvalhistory;
          // this.Team = response.data.metalayout.team;
          // this.pathSetting = response.data.metalayout.pathsetting;
          // // this.groupfieldattributes =
          const sections = response.data.metalayout.metalayoutgroups;
          const sectionfields = response.data.metalayout.metalayoutgroupfields;
          const buttons = response.data.metalayout.metalayoutbuttons;
          const groupproperties =
            response.data.metalayout.metalayoutgroupfields;

          console.log(groupproperties);

          // Create an array to hold the mapped properties
          const mappedProperties = [];

          groupproperties.forEach((property: any) => {
            console.log("property!!", property.attributes);

            // Assuming fieldDataObject is an empty object or initialized appropriately
            var fieldDataObject = {};

            fieldDataObject[property.fieldname] = property;
            mappedProperties.push(fieldDataObject);

            // Emit the property here
            this.retrievedProperties.emit(mappedProperties);
            console.log(
              "mapped properties",
              fieldDataObject[property.fieldname]
            );
          });

          if (sections) {
            console.log("Sections", sections);
            const mappedSections = sections.map((section) => {
              const newSection = {
                id: section.id,

                sectionName: section.name,
                detailPage: section.showondetailpage,
                editPage: section.showoneditpage,
                onnew: section.onnew != null ? section.onnew : true,
                onedit: section.onedit != null ? section.onedit : true,
                imageSection: section.imagesection,
                systemSection: section.systemsection,
                // column: section.columncount,
                column: parseInt(section.columncount),
                droppedDataFieldList: [],
              };

              const mappedSectionFields = sectionfields.map((sectionfield) => {
                if (sectionfield.metagroupid == section.id) {
                  const fields = this.inputField.map((field) => {
                    if (sectionfield.metafieldid == field.id) {
                      field.dropped = true;
                      field.attributes = sectionfield.attributes;
                      newSection.droppedDataFieldList.push(field);

                      this.groupfieldattributes[field.fieldname] =
                        field.attributes;

                      this.groupfields[field.fieldname] = sectionfield;

                      console.log("groupfields", this.groupfields);
                      console.log("sectionfield", sectionfield);
                    }
                  });
                }
              });

              this.sectionList.push(newSection);

              console.log("Section Pushed");

              this.translateGroupForm.setControl(
                "translategroup",
                this.fb.array([])
              );

              if (this.layoutgrouplabel) {
                // Filter translations for the current section
                const sectionTranslations = this.layoutgrouplabel.filter(
                  (translation) => translation.metalayoutgroupid === section.id
                );

                sectionTranslations.forEach((translation) => {
                  const translateGroup = this.fb.group({
                    languageCode: [
                      translation.languagecode,
                      Validators.required,
                    ],
                    translatedName: [
                      translation.translatedlabel,
                      Validators.required,
                    ],
                  });
                  this.translategroup.push(translateGroup);
                });

                // Update sectionsData with metalayoutgrouptranslation data
                const existingSectionIndex = this.sectionsData.findIndex(
                  (s) => s.sectionName === section.name
                );

                if (existingSectionIndex !== -1) {
                  this.sectionsData[existingSectionIndex].translategroup =
                    sectionTranslations.map((translation) => ({
                      languageCode: translation.languagecode,
                      translatedName: translation.translatedlabel,
                    }));
                } else {
                  this.sectionsData.push({
                    sectionName: section.name,
                    translategroup: sectionTranslations.map((translation) => ({
                      languageCode: translation.languagecode,
                      translatedName: translation.translatedlabel,
                    })),
                  });
                }
              }
              console.log(this.layoutgrouplabel);
              console.log(this.translateGroupForm.get("translategroup").value);
              console.log(this.sectionsData);
            });
            // return mappedSections;

            this.sectionList.sort(function (a, b) {
              // console.log("aaaaaaaaa", b);
              return a.groupsequence - b.groupsequence; // Adjust the property based on which you want to sort
            });
          }
          this.isLoading = false;
        }
      },
      (error: any) => {
        console.error("Error retrieving saved data:", error);
        this.errorMessage = error.message;
        this.isError = true;
        this.isLoading = true;
      }
    );
    this.isDataLoaded = true;
  }

  delete1() {
    this.showElements1 = !this.showElements1;
    console.log("Number Deleted");
  }

  hiddenIndex: number = -1;

  samp = "Sample Text";

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  onSectionDrag(event: DragEvent) {
    event.dataTransfer.setData("text/plain", "Section");
    console.log("Mode", this.mode);
  }
  onSectionDragStart(event: DragEvent, section: any) {
    event.dataTransfer.setData("text/plain", JSON.stringify(section));
  }

  onSectionDragOver(event: DragEvent) {
    event.preventDefault();
  }

  generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  handleSectionPropertiesChanged(properties: any, index: number) {
    this.sectionName = properties.sectionName;
    this.detailPage = properties.detailPage;
    this.editPage = properties.editPage;
    this.column = properties.column;
    this.imageSection = properties.imageSection;
    this.systemSection = properties.systemSection;

    if (index >= 0 && index < this.sectionList.length) {
      const section = this.sectionList[index];
      section.sectionName = properties.sectionName;
      section.detailPage = properties.detailPage;
      section.editPage = properties.editPage;
      section.onnew = properties.onnew;
      section.onedit = properties.onedit;
      section.imageSection = properties.imageSection;
      section.systemSection = properties.systemSection;
      section.column = properties.column;
    }

    console.log("handleSectionPropertiesChanged", properties);
    console.log("Updated sectionList:", this.sectionList);
    return this.sectionList;
  }

  handleFieldPropertiesChanged(properties: any) {
    const propertiesfield = {
      readonly: properties.properties.readonly,
      required: properties.properties.required,
    };

    this.propertiesfield[properties.fieldname] = propertiesfield;
    console.log("propertiesfield", propertiesfield);
  }

  handleGroupAttributesChanged(properties: any, fieldname: any) {
    const groupfieldattributes = {
      hidden: properties.attributes.hidden,
      islink: properties.attributes.islink,
      linkfield: properties.attributes.linkfield,
      linkrelativeurl: properties.attributes.linkrelativeurl,
      object: properties.attributes.object,
      recordtypeexist: properties.attributes.recordtypeexist,
    };
    this.groupfieldattributes[properties.fieldname] = groupfieldattributes;

    console.log("handleGroupAttributesChanged", this.groupfieldattributes);
    console.log(
      "handleGroupAttributesChanged__fieldname",
      properties.fieldname
    );
    console.log("groupfieldattributes", groupfieldattributes);

    return groupfieldattributes;
  }

  onSectionDrop(event: DragEvent) {
    event.preventDefault();
    const droppedData = event.dataTransfer.getData("text/plain");
    if (droppedData === "Section") {
      const newSection = {
        id: this.generateUniqueId(),
        sectionName: "New Section",
        detailPage: false,
        editPage: true,
        onnew: true,
        onedit: true,
        imageSection: false,
        systemSection: false,
        column: 2,
        droppedDataFieldList: [],
      };

      this.sectionList.push(newSection);
      console.log("Empty Section Created");
      console.log("Section Id:", newSection.id);
      console.log("Updated sectionList:", this.sectionList);
      console.log("Updated sectionList:", newSection);

      return newSection;
    }
    // return null;
  }
  onSectionDrops(event: DragEvent, newIndex: number) {
    event.preventDefault();
    const droppedIndex = Number(event.dataTransfer.getData("text/plain"));
    if (droppedIndex && droppedIndex !== newIndex) {
      const section = this.sectionList[droppedIndex];
      this.sectionList.splice(droppedIndex, 1);
      this.sectionList.splice(newIndex, 0, section);
      console.log("index", droppedIndex);
    }
  }

  handleDroppedDataEvent(data: any) {
    console.log("handleDroppedDataEvent", data);
    const sectionId = data.sectionId;
    const droppedfield = data.field;
    console.log("Field Data", droppedfield);

    const fields = this.inputField.map((field) => {
      if (droppedfield.id == field.id) {
        field.dropped = true;
      }
    });
  }

  handleFieldDeleted(deletedfield) {
    console.log("deletedfield", deletedfield.id);
    const fields = this.inputField.map((field) => {
      console.log("field", field.id);

      if (deletedfield.id == field.id) {
        field.dropped = false;
      }
    });
  }

  handleDroppedButtonEvent(button: any) {
    console.log("handleDroppedButtonEvent", button);

    // this.droppedDataButtonList.push(button);
    const droppedbutton = button;
    console.log("Button Data", droppedbutton);

    const buttons = this.layoutbutton.map((buttonss) => {
      if (button.id == buttonss.id) {
        button.dropped = true;
      }
    });

    console.log("droppedDataButtonList!!!", this.droppedDataButtonList);
  }

  handleSectionDeleted(index: number): void {
    this.sectionList.splice(index, 1);
    console.log("index", index);
    console.log("sectionList", this.sectionList);
  }

  onDragOver2(event: DragEvent) {
    event.preventDefault();
  }

  properties(): void {
    const dialogRef = this.dialog.open(PropertiesDialogComponent, {
      data: {
        displayname: this.displayName,
        viewname: this.viewName,
      },
      // data: {
      //   displayname: this.displayName,
      //   name: this.Name,
      //   fieldhistory: this.fieldHistory,
      //   approvalhistory: this.approvalHistory,
      //   team: this.Team,
      //   pathsetting: this.pathSetting,
      //   mode: this.mode,
      // },
    });

    this.propertiesDialog = dialogRef.componentInstance;
    this.propertiesDialog.setParent(this);

    dialogRef.componentInstance.openTranslateDialog.subscribe(
      (open: boolean) => {
        this.openTranslateDialog(open);
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
    });
  }

  openTranslateDialog(open: boolean): void {
    console.log("Open Translate Dialog:", open);
    if (open) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = "560px"; // Set the width
      dialogConfig.height = "400px"; // Set the height
      // this.dialog.open(this.translateDialog,dialogConfig);
      this.dialogRefTranslation = this.dialog.open(
        this.translateDialog,
        dialogConfig
      );
    }
  }

  cancel() {
    // this.router.navigate(['home/metaobjectlist'])
    this.router.navigateByUrl("home/globalaction");
  }

  receiveEnteredName(displayname: string, viewname: string) {
    this.displayName = displayname;
    this.viewName = viewname;
    console.log("Name:", displayname);
    console.log("Entered Name:", this.viewName);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  postOption: any[] = [];

  save() {
    var metaGroupField = {
      metaobjectid: this.metaobjectId,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      metagroupid: this.metaLayoutGroupId,
    };

    console.log("metaGroupField:", metaGroupField);

    var save_data = this.sectionList.map((items) => {
      console.log("save_data", items);
      return items;
    });

    console.log("Saved Data:", save_data);

    this.isLoading = false;
    this.isError = false;

    // if (this.displayName) {
    // } else {
    //   this.showWarning("Name is mandatory");
    // }

    console.log("layout data:", save_data);

    if (save_data.length == 0) {
      this.showWarning("You must have atleast one field in the selected list");
      return;
    }

    save_data.forEach((item) => {
      viewName = item["fieldname"];
      return item;
    });

    var viewName = this.viewName;

    // this.metalayoutName = viewName;

    var targetURL = "api/v1/" + this.metaobjectName + "/metalayout/new";

    var metalayoutAttributes = {
      relatedlistflag: false,
      notesandattachments: false,
      activity: false,
    };

    console.log("mode", this.mode);

    var hasRecordType = this.recordTypes.length > 0 ? true : false;

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metalayout: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          relatedobjectid: "",
          hasrecordtype: hasRecordType,
          mode: this.mode,
          id: this.metalayoutId,
          // displayname: save_data [0] ['labelname'],
          displayname: this.displayName,
          viewname: this.viewName,
          name: this.metalayoutName,
          fieldhistory: false,
          approvalhistory: false,
          team: false,
          pathsetting: false,
          action: "New",
          layouttype: "Global Layout",
          targeturl: targetURL,
          columncount: this.detailForm.controls["columncount"].value,
          tabkeyorder: this.detailForm.controls["tabkeyorder"].value.trim(),
          hascustomview: this.detailForm.controls["hascustomview"].value,
          clonable: this.detailForm.controls["clonable"].value,
          editable: this.detailForm.controls["editable"].value,
          deletable: this.detailForm.controls["deletable"].value,
          haskanbanview: this.detailForm.controls["haskanbanview"].value,
          searchtext: this.detailForm.controls["searchtext"].value.trim(),
          sortby: this.detailForm.controls["sortby"].value.trim(),
          sortorder: this.detailForm.controls["sortorder"].value.trim(),
          pagesize: this.appConfig.appDefaultPageSize,
          pagenumber: 1,
          userid: localStorage.getItem("crm_userid"),
          publicaccess: this.detailForm.controls["publicaccess"].value,

          filterbyowner: "",
          queueid: "",
          queuename: "",
          active: true,
          attributes: metalayoutAttributes,
          metalayoutbuttonsprovided: true,
          metaprofilelayouts: [],
          metalayoutgroups: [],
          metaprofilelayoutwebs: [],
          metalayoutbuttons: [], //will be served at server
          layoutlabeltranslation: [],
          layoutgrouplabeltranslation: [], //will be served at server
        },
      },
    };
    console.log("postOption", postOption);
    //****** metaprofilelayout  *********/

    var metaProfileLayoutId = "";
    //metaprofilelayout
    metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
    console.log("metaprofileLayoutId:", metaProfileLayoutId);

    var metaProfileLayout = {
      id: metaProfileLayoutId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      recordtypeid: "",
      profileid: "",
      description: "",
      actiontype: "",
      active: true,
      attributes: {},
    };
    console.log("metaProfileLayout", metaProfileLayout);

    //push metaprofilelayout to request data (postoption)
    postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);

    //***Done***//

    //****** metalayoutgroup  *********/

    //get metalayoutgroup details and assign it to postoption

    this.metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");

    var groupSequence = 0;

    if (this.sectionList) {
      this.sectionList.forEach((section) => {
        this.metaLayoutGroupIdSection = this.guid.getGUID("metalayoutgroup");
        var metaLayoutGroup = {
          id: this.metaLayoutGroupIdSection,
          metaobjectid: this.metaobjectId,
          embeddedobject: false,
          parentobjectid: "",
          metalayoutid: this.metalayoutId,
          name: section.sectionName,
          groupsequence: groupSequence,
          showondetailpage: section.detailPage,
          showoneditpage: section.editPage,
          onnew: section.onnew != null ? section.onnew : true,
          onedit: section.onedit != null ? section.onedit : true,
          imagesection: section.imageSection,
          systemsection: section.systemSection,
          columncount: section.column,
          active: true,
          metalayoutgroupfields: [],
        };

        console.log("arrMetaGroupField!!!", metaGroupField);

        var index = 1;
        console.log("dropped Section,", section);

        section.droppedDataFieldList.forEach((droppedField: any) => {
          console.log("droppedField", droppedField);

          var metaGroupField = {
            id: this.guid.getGUID("metalayoutgroupfield"),
            metaobjectid: this.metaobjectId,
            embeddedobject: false,
            parentobjectid: "",
            metalayoutid: this.metalayoutId,
            metagroupid: this.metaLayoutGroupIdSection,
            metafieldid: droppedField.id,
            fieldname: droppedField.fieldname,
            fieldtype: droppedField.fieldtype,
            labelname: droppedField.labelname,
            attributes: {},
            supportingobjectid: "",
            supportingfield: false,
            standard: droppedField.standard,
            fieldsequence: index,
            defaultvalue: droppedField.defaultvalue,
            // required: droppedField.required,
            primary: droppedField.primaryfield,
            // visible: droppedField.visibility,
            visible: true,
            readonly: false,
            // readonly:this.readonly,
            required: false,
            derivedfield: false,
            active: true,
            groupfieldattributes: {},
            // groupfieldattributes:this.groupfieldattributes,
            createddate: "2023-06-05 17:41:39.821061",
          };
          // if (this.propertiesfield.hasOwnProperty(droppedField.fieldname)) {
          //   const fieldProperties =
          //     this.propertiesfield[droppedField.fieldname];
          //   // Assign readonly and required from fieldProperties
          //   metaGroupField.readonly = fieldProperties.readonly;
          //   metaGroupField.required = fieldProperties.required;
          // }
          if (this.propertiesfield.hasOwnProperty(droppedField.fieldname)) {
            const fieldProperties =
              this.propertiesfield[droppedField.fieldname];
            // Assign readonly and required from fieldProperties
            metaGroupField.readonly = fieldProperties.readonly;
            metaGroupField.required = fieldProperties.required;
          } else {
            const fieldProperties = this.groupfields[droppedField.fieldname];
            metaGroupField.readonly = fieldProperties.readonly;
            metaGroupField.required = fieldProperties.required;
          }
          var metaGroupFieldAttributes = {};
          if (droppedField.labelname) {
            console.log("droppedField.labelname");
            metaGroupFieldAttributes = {
              recordtypeexist: "",
              object: "",
              linkfield: "",
              hidden: false,
              linkrelativeurl: "",
              islink: false,
            };
          }
          if (droppedField.fieldtype.toLowerCase() == "id") {
            metaGroupFieldAttributes = {
              recordtypeexist: "false",
              object: "",
              linkfield: "",
              hidden: true,
              linkrelativeurl: "",
              islink: false,
            };
          } else if (droppedField.fieldname.toLowerCase() == "name") {
            //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
            var linkrelativeurl = "web/v1/lead/leadview";
            metaGroupFieldAttributes = {
              recordtypeexist: "" + hasRecordType,
              object: this.metaobjectName,
              linkfield: "id",
              hidden: false,
              linkrelativeurl: linkrelativeurl,
              islink: true,
            };
          }
          //  else if (Object.keys(this.groupfieldattributes).length >0) {
          else if (this.groupfieldattributes[droppedField.labelname]) {
            console.log(this.groupfieldattributes);
            console.log(droppedField);
            metaGroupFieldAttributes =
              this.groupfieldattributes[droppedField.labelname];
          } else {
            metaGroupFieldAttributes = {
              recordtypeexist: "",
              object: "",
              linkfield: "",
              hidden: false,
              linkrelativeurl: "",
              islink: false,
            };
          }

          metaGroupField.groupfieldattributes = metaGroupFieldAttributes;
          metaLayoutGroup.metalayoutgroupfields.push(metaGroupField);
          index++;
        });

        postOption.data.metalayout.metalayoutgroups.push(metaLayoutGroup);
      });

      if (this.mode.toLocaleLowerCase() == "edit") {
        if (this.sectionsData) {
          if (this.sectionsData && Array.isArray(this.sectionsData)) {
            const arrTranslatedGroupLayouts = [];

            this.sectionsData.forEach((sectionData) => {
              const matchingSection = this.sectionList.find(
                (section) => section.sectionName === sectionData.sectionName
              );

              if (matchingSection) {
                const matchingMetaLayoutGroup =
                  postOption.data.metalayout.metalayoutgroups.find(
                    (group) => group.name === sectionData.sectionName
                  );

                if (matchingMetaLayoutGroup) {
                  sectionData.translategroup.forEach(
                    (translatedLayoutGroupLabel) => {
                      const layoutGroupLabelTranslation = {
                        id: this.guid.getGUID(
                          "metalayoutgrouplabeltranslation"
                        ),
                        organizationid: localStorage.getItem("crm_orgid"),
                        metalayoutid: this.metalayoutId,
                        metalayoutgroupid: matchingMetaLayoutGroup.id, // Use the matching metaLayoutGroupId
                        languagecode: translatedLayoutGroupLabel.languageCode,
                        translatedlabel:
                          translatedLayoutGroupLabel.translatedName,
                        active: true,
                      };
                      arrTranslatedGroupLayouts.push(
                        layoutGroupLabelTranslation
                      );
                    }
                  );
                }
              }
            });

            postOption.data.metalayout.layoutgrouplabeltranslation =
              arrTranslatedGroupLayouts;
          } else {
            console.error("Invalid or undefined 'sectionsData'");
          }
        }

        console.log("SectionList:", this.sectionList);
      }

      console.log("SectionList:", this.sectionList);
    }

    console.log("Section List", this.sectionList);

    var metaLayoutButtonId = "";
    var metaLayoutButton;
    //metalayoutbutton
    metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");
    console.log("metaLayoutButtonId", metaLayoutButtonId);

    if (this.droppedDataButtonList) {
      this.droppedDataButtonList.forEach((button) => {
        metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");
        metaLayoutButton = {
          id: metaLayoutButtonId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          metalayoutid: this.metalayoutId,
          metalayoutname: this.metalayoutName,
          labelname: button.labelname,
          name: button.name,
          description: button.description,
          buttontype: button.buttontype,
          actiontype: "",
          active: "true",
          attributes: {},
        };
        console.log("buttonnn", button);

        console.log("buttonnn", button.labelname);
        console.log("buttonnn", button.name);
        if (metaLayoutButton) {
          postOption.data.metalayout.metalayoutbuttons.push(metaLayoutButton);
        }
      });

      //****** metaprofilelayout  *********/

      //metaprofilelayoutweb
      this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");

      var metaProfileLayoutWeb = {
        id: this.metaProfileLayoutWebId,
        metaobjectid: this.metaobjectId,
        metaobjectname: this.metaobjectName,
        embeddedobject: false,
        parentobjectid: "",
        metalayoutid: this.metalayoutId,
        metalayoutname: this.metalayoutName,
        recordtypeid: null,
        recordtypename: "",
        profileid: null,
        profilename: "",
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        description: "",
        actiontype: this.actionType,
        active: true,
        layouttype: "Global Layout",
        layoutjsontext: {},
        fieldjsontext: {},
        criteriajsontext: {},
      };

      //push metaprofilelayout to request data (postoption)
      postOption.data.metalayout.metaprofilelayoutwebs.push(
        metaProfileLayoutWeb
      );

      this.isLoading = true;

      if (this.mode.toLocaleLowerCase() == "edit") {
        if (this.translatedLabels) {
          var arrtranslatedLayouts = [];
          for (let translatedlayoutlabel of this.translatedLabels) {
            var layoutlabelTranslation = {
              id: this.guid.getGUID("metalayoutlabeltranslation"),
              organizationid: localStorage.getItem("crm_orgid"),
              metalayoutid: this.metalayoutId,
              languagecode: translatedlayoutlabel.languageCode,
              translatedlabel: translatedlayoutlabel.translatedName,
              active: true,
            };

            //push it to array
            arrtranslatedLayouts.push(layoutlabelTranslation);
          }
          postOption.data.metalayout.layoutlabeltranslation =
            arrtranslatedLayouts;
        }
      }

      console.log("postOption End", postOption);

      this.isLoading = true;

      this.dataService.layoutData(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.showSuccess(res.message);
            this.isLoading = false;
            this.router.navigateByUrl("/home/globalaction");
          } else {
            console.log("error while saving");
            this.showError(res.message);
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.showError(err.message);
          this.isError = true;
          this.isLoading = false;
        }
      );
    }
  }
}
